import { CIMSTags } from '../..'
import { LabTechTagsProps } from './types'
import { useLabTechTagProps } from './hooks/useLabTechTagProps'

/**
 * renders a {@link CIMSTags} component for LabTech records
 *
 * @param props {@link LabTechTagsProps}
 * @returns
 */
const LabTechTags: React.FC<LabTechTagsProps> = ({ labTechs }) => {
  const labTechTagProps = useLabTechTagProps()
  return <CIMSTags tags={labTechs.map(labTechTagProps)} />
}

export default LabTechTags
